module.exports = __webpack_public_path__ + "static/media/allan_footer.9d5a1c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/allan_footer.png
// module id = 241
// module chunks = 0